export const isMobile = () =>
  typeof window !== "undefined" &&
  !!window.navigator.userAgent.match(
    /Android|webOS|iPhone|iPod|iPad|Blackberry/i,
  );
